import { SvgIcon } from '@material-ui/core'

export const PlusIcon = props => (
  <SvgIcon {...props} style={{ fill: 'none' }}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 28 28"
      fill="none"
    >
      <path
        d="M14 5.83333V22.1667M5.83334 14H22.1667"
        stroke="#667085"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </SvgIcon>
)
